export default __webpack_public_path__ + "ca068f6eb983185a5a1c2b356b371c9c.png";